export default "__VITE_ASSET__BZpBTlwO__"